import { render } from "./UserProfileSuccess.vue?vue&type=template&id=22dd8fa0"
import script from "./UserProfileSuccess.vue?vue&type=script&lang=js"
export * from "./UserProfileSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__